// import React, { Component } from 'react';
// import moment from 'moment';
// import { connect } from 'react-redux';
// import {
//   Table, TableRow, TableCell, TableHead, TableBody
// } from '@material-ui/core';
// import { Line } from 'react-chartjs-2';
// import { get, map, take, reverse } from 'lodash';

// import AdminLayout from '../lib/admin-layout';
// import AdminLayoutHelper from '../components/admin-layout-helper';
// import { browseDaily } from '../state/system_monitor';
// import { readPersonalInfo } from '../state/personal_info';

// import Loading from '../components/loading';

// import { baseStyles, colors } from '../../theme/style';

// class PatientSystemMonitor extends Component {
//   state = {
//     new: false,
//     compliance_hours: '',
//     serial_number: ''
//   };

//   componentWillMount = () => {
//     const patientId = this.props.userId;
//     if(!patientId){
//       return this.props.router.push('/app')
//     }
    
//     this.props.readPersonalInfo(patientId);
//     this.props.browseDaily(patientId);
//   }

//   handleChange = event => {
//     this.setState({ [event.target.name]: event.target.value })
//   };

  
//   render() {
//     let birth_date_display;
//     let name_display;
//     const { personalInfo, systemMonitor } = this.props;

//     let temperatureChartData;
//     let batteryChartData;

//     if(systemMonitor.browseDaily) {
//       const rows = take(systemMonitor.browseDaily, 20);
//       const labels = reverse(rows.map(r => moment(r.day).format('MM-DD-YYYY')));
//       const batteryData = reverse(rows.map(r => r.average_battery));
//       const temperatureData = reverse(rows.map(r => r.average_temperature));
//       batteryChartData = {
//         labels,
//         datasets: [
//           {
//             label: 'Battery',
//             fill: false,
//             lineTension: 0.1,
//             backgroundColor: 'rgba(75,192,192,0.4)',
//             borderColor: 'rgba(75,192,192,1)',
//             pointBorderColor: 'rgba(75,192,192,1)',
//             pointBackgroundColor: '#fff',
//             pointBorderWidth: 1,
//             pointHoverRadius: 5,
//             pointHoverBackgroundColor: 'rgba(75,192,192,1)',
//             pointHoverBorderColor: 'rgba(220,220,220,1)',
//             pointHoverBorderWidth: 2,
//             pointRadius: 3,
//             pointHitRadius: 10,
//             data: batteryData
//           }
//         ]
//       };

//       temperatureChartData = {
//         labels,
//         datasets: [
//           {
//             label: 'Temperature',
//             fill: false,
//             lineTension: 0.1,
//             backgroundColor: 'rgba(75,192,192,0.4)',
//             borderColor: 'rgba(75,192,192,1)',
//             pointBorderColor: 'rgba(75,192,192,1)',
//             pointBackgroundColor: '#fff',
//             pointBorderWidth: 1,
//             pointHoverRadius: 5,
//             pointHoverBackgroundColor: 'rgba(75,192,192,1)',
//             pointHoverBorderColor: 'rgba(220,220,220,1)',
//             pointHoverBorderWidth: 2,
//             pointRadius: 3,
//             pointHitRadius: 10,
//             data: temperatureData
//           }
//         ]
//       };
//     }

//     if (personalInfo.readPersonalInfo) {
//       const { birth_date = '', first_name = '', last_name = '' } = personalInfo.readPersonalInfo;
//       if (birth_date) {
//         birth_date_display = <span>{moment(birth_date).format('MMM D, YYYY')}</span>;
//       }

//       if (first_name && last_name) {
//         name_display = <h1>{first_name} {last_name}</h1>;
//       }
//     }


//     if (systemMonitor.readsystemMonitorPending || personalInfo.readPersonalInfoPending) {
//       return <Loading />;
//     }
//     return (<AdminLayout {...this.props}>
//       <AdminLayoutHelper page="Patient List" link="/app" header="">
//         <div style={baseStyles.patientName}>
//           {name_display}
//         </div>
//         <div style={baseStyles.birthDate}>
//           Birth Date: &nbsp;
//           {birth_date_display}
//         </div>


//         <div>
//           <h2>Daily System Monitor</h2>
//           {systemMonitor.browseDaily && systemMonitor.browseDaily.length ? (
//             <div style={{ margin: '50px 25px 0 0', minHeight: 500, minWidth: 450, maxWidth: 700, flex: 1 }}>
//             <Line
//               data={batteryChartData}
//             />
//             <Line
//               data={temperatureChartData}
//             />
//           </div>
//           ) : ''}
//           <Table style={baseStyles.table}>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Day</TableCell>
//                 <TableCell>Avg. Temperature</TableCell>
//                 <TableCell>Avg. Batter Voltage</TableCell>
//                 <TableCell>Data Points</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody style={baseStyles.body}>
//               {map(systemMonitor.browseDaily, (sm, idx) => {
//                 return (
//                   <TableRow style={baseStyles.row} key={idx}>
//                     <TableCell>{moment(sm.day).format('MM-DD-YYYY')}</TableCell>
//                     <TableCell style={{textAlign:'right'}}>{sm.average_temperature.toFixed(2)}</TableCell>
//                     <TableCell style={{textAlign:'right'}}>{sm.average_battery.toFixed(2)}</TableCell>
//                     <TableCell style={{textAlign:'right'}}>{sm.count}</TableCell>
//                   </TableRow>
//                 );
//                 })}
//             </TableBody>
//           </Table>
//         </div>
//       </AdminLayoutHelper>
//     </AdminLayout>);
//     }
//   }

// function mapStateToProps(state, ownProps) {
//   const { user, clinic, personalInfo, users, systemMonitor } = state;
//   const userId = get(ownProps, 'location.state.userId');
//   return {
//     user,
//     userId,
//     clinic,
//     personalInfo,
//     users,
//     systemMonitor
//   };
// }


// export default connect(mapStateToProps, { browseDaily, readPersonalInfo })(PatientSystemMonitor);


import React, { Component } from 'react';


class PatientSystemMonitor extends Component {
  

  render()
  {
    return <div></div>
  }
  
  }




export default PatientSystemMonitor
